import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { DiagramPartRemovePayload } from '../models/part-remove-payload';

export const DiagramPartDetailsRemovePartActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[diagram/part] Remove part'),
  requestFail: uniqueActionType('[diagram/part] Remove part fail'),
  requestSuccess: uniqueActionType('[diagram/part] Remove part success'),
  requestClearErrors: uniqueActionType('[diagram/part] Remove part clear errors'),
  requestClear: uniqueActionType('[diagram/part] Remove part clear')
};

export class DiagramPartDetailsRemovePartAction implements PayloadAction {
  readonly type = DiagramPartDetailsRemovePartActionTypes.request;

  constructor(public payload: SendByIdPayload<DiagramPartRemovePayload>) {
  }
}

export class DiagramPartDetailsRemovePartFailAction implements PayloadAction {
  readonly type = DiagramPartDetailsRemovePartActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DiagramPartDetailsRemovePartSuccessAction implements PayloadAction {
  readonly type = DiagramPartDetailsRemovePartActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DiagramPartDetailsRemovePartClearErrorsAction implements PayloadAction {
  readonly type = DiagramPartDetailsRemovePartActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DiagramPartDetailsRemovePartClearAction implements PayloadAction {
  readonly type = DiagramPartDetailsRemovePartActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
